<script>
    import { getBillingStatus, getFeeEstimateDisplayStatus, getQuoteOnlyDisplayStatus } from "../../../../../Utils/utilFunctions.svelte";

    import { TableComponentContainer } from "../../../../Common/index.svelte";

    export let row = {};

    $: getFillIndex = _getNumOfFillIndex(isFeeEstimate ? getFeeEstimateDisplayStatus(row) : row.billingStatus);

    $: showHandOverText = row?.handOver;

    $: isFeeEstimate = row?.quoteOnly;

    // HELPER FUNCTIONS
    const _getNumOfFillIndex = (status) => {
        if(isFeeEstimate) {
            switch (status) {
                case 0:
                    return 1;
                case 1:
                    return 2;
                case 2:
                case 3:
                    return 3;
                case 5:
                    return 4;
                default:
                    return 0;
            }
        }
        else {
            switch (status) {
                case 0:
                    return 1;
                case 1:
                    return 2;
                case 2:
                    return 3;
                case 3:
                    return 4;
                case 4:
                    return 5;
                case 5:
                    return 6;
                default:
                    return 0;
            }
        }
        
    };

   
</script>

<TableComponentContainer customContainerClass="min-w-[120px]">
    <div class="flex flex-col gap-y-2 flex-1 items-center justify-start">
        <p
            class="w-full text-left"
            style="color: {!isFeeEstimate ? getBillingStatus(row.billingStatus, 'color') : getQuoteOnlyDisplayStatus(getFeeEstimateDisplayStatus(row), "color")}"
        >
            {isFeeEstimate ? getQuoteOnlyDisplayStatus(getFeeEstimateDisplayStatus(row)) : getBillingStatus(row.billingStatus)}
        </p>
        <div class="flex w-full gap-x-1 items-center justify-start">
            {#each Array(isFeeEstimate ? 4 : 6).fill(null) as _, i}
                <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle
                        cx="5"
                        cy="5"
                        r="5"
                        fill={i < getFillIndex
                            ? isFeeEstimate ? getQuoteOnlyDisplayStatus(getFeeEstimateDisplayStatus(row), "color") : getBillingStatus(row.billingStatus, "color")
                            : "#D9D9D9"}
                    />
                    <circle cx="5" cy="5" r="3.75" fill="white" />
                    <circle
                        cx="5"
                        cy="5"
                        r="2.5"
                        fill={i < getFillIndex
                            ? isFeeEstimate ? getQuoteOnlyDisplayStatus(getFeeEstimateDisplayStatus(row), "color") : getBillingStatus(row.billingStatus, "color")
                            : "#D9D9D9"}
                    />
                </svg>
            {/each}
        </div>

        {#if showHandOverText}
            <p class="w-full text-left text-bold">
                ({row.handOver == 1 || row.handOver == 2
                    ? "Handed Over"
                    : "Pending Doctor Review"})
            </p>
        {/if}
    </div>
</TableComponentContainer>
